import { Injectable} from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable} from 'rxjs/Observable';
import { DomainService } from '../services';

@Injectable()
export class DomainGuard implements CanActivate {

    constructor(
        private router: Router,
        private domainService: DomainService
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.domainService.isDomainVerified()) {
            return true;
        }
        else {
            this.domainService.deleteDomainVerified();
            this.router.navigate(['/']);
        }
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/guards/domain.guard.ts